import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { ContractDataPickerComponent } from './contract-data-picker.component';

@NgModule({
  declarations: [
    ContractDataPickerComponent
  ],
  imports: [
    SharedModule
  ],
  exports:[
    ContractDataPickerComponent
  ]
})
export class ContractDataPickerModule { }
